export default __webpack_public_path__ + "static/media/readability-of-stories.e58f2e26.pdf";